module.constant('version', '0.1');